import { PermissionsContext } from 'contexts/PermissionsContext';
import { createContext } from 'react';

// this is here to make vite HMR behave
// https://github.com/vitejs/vite/issues/3301
export const PermissionsContextDef = createContext<PermissionsContext | null>(null);
